import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

const FilledPaths = () => (
  <g fillRule="evenodd">
    <path d="M12.557 10.66v14.096l11.372-4.88V5.685zM0 19.78l11.371 4.915V10.6L5.568 8.053v8.453l-1.184-.516V7.58L.002 5.686zM11.964 9.595l-5.508-2.37L17.532 2.43l5.507 2.37zM11.964 0L.891 4.798l4.086 1.777 11.075-4.797z" />
  </g>
);

const OutlinePath = () => (
  <path d="M25.6866 7.03534L13.7923 0.168713C13.4014 -0.0562377 12.9178 -0.0562377 12.5269 0.168713L0.632674 7.03815C0.241822 7.2631 0 7.68207 0 8.13197V21.868C0 22.3179 0.241822 22.7369 0.632674 22.9647L12.5269 29.8313C12.721 29.9438 12.9403 30 13.1596 30C13.3789 30 13.5983 29.9438 13.7923 29.8313L25.6894 22.9647C26.0802 22.7397 26.3221 22.3207 26.3221 21.8708V8.13197C26.3221 7.68207 26.0802 7.2631 25.6894 7.03534H25.6866ZM13.1596 13.8598L8.83775 11.346L18.6737 5.25823L23.3302 7.94639L13.1596 13.8598ZM13.1596 2.07517L16.7363 4.14191L6.90599 10.2268L2.98622 7.9492L13.1596 2.07517ZM1.96832 9.63071L5.98931 11.9702V19.0112C5.98931 19.1124 6.04274 19.2052 6.12991 19.2558L7.53585 20.0684C7.72425 20.1753 7.95763 20.0403 7.95763 19.8238V13.1146L12.1755 15.5666V27.354L1.96832 21.4603V9.63071ZM14.1438 27.354V15.5666L24.3509 9.63071V21.4603L14.1438 27.354Z" />
);

function circledInnerTransform({ outerSize, iconSize, artExtent, centerX, centerY }) {
  const innerIconSize = iconSize ?? outerSize / 2;
  const scale = (innerIconSize * 80) / (artExtent * outerSize);
  return `translate(40 40) scale(${scale}) translate(${-centerX} ${-centerY})`;
}

export default function TestOrderIcon({
  color = "#1A1A1A",
  width,
  iconSize,
  style,
  variant = "filled",
  withCircle = false
}) {
  const isFilled = variant === "filled";

  if (withCircle) {
    const outerSize = width;
    const iconTransform = isFilled
      ? circledInnerTransform({
          outerSize,
          iconSize,
          artExtent: 25,
          centerX: 12,
          centerY: 12.5
        })
      : circledInnerTransform({
          outerSize,
          iconSize,
          artExtent: 30,
          centerX: 13.5,
          centerY: 15
        });

    return (
      <Svg
        as="svg"
        xmlns="http://www.w3.org/2000/svg"
        width={outerSize}
        height={outerSize}
        minWidth={outerSize}
        minHeight={outerSize}
        viewBox="0 0 80 80"
        fill={color}
        style={style}
      >
        <CirclePath color={color} />
        <g transform={iconTransform}>{isFilled ? <FilledPaths /> : <OutlinePath />}</g>
      </Svg>
    );
  }

  if (isFilled) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 25"
        width={width}
        fill={color}
        style={style}
      >
        <FilledPaths />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={(width * 30) / 27}
      viewBox="0 0 27 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <OutlinePath />
    </svg>
  );
}
